module.exports = __webpack_public_path__ + "assets/img/32_636_big.2ac2ae23.jpg";